import { render } from "./CertificateDetails.vue?vue&type=template&id=ebd327f8&scoped=true"
import script from "./CertificateDetails.vue?vue&type=script&lang=js"
export * from "./CertificateDetails.vue?vue&type=script&lang=js"

import "./CertificateDetails.vue?vue&type=style&index=0&id=ebd327f8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebd327f8"]])

export default __exports__